import keyMirror from 'react-utils/keyMirror';
export const StateKeys = {
  DIALOG_KEY: 'dialogKey',
  PANEL_KEY: 'panelKey',
  DIALOG_FORM_GUID: 'dialogFormGuid',
  DATA: 'data'
};
export const DialogKeys = keyMirror({
  PAGE_LIST: null,
  DELETE_FORM: null,
  ASSIGN_TEAMS: null,
  CREATE_SUPPORT_FORM: null,
  TRANSFORM_TO_TICKET: null,
  DISABLE_TICKET_WARNING: null,
  EXPORT_DASHBOARD_DATA: null,
  EXPORT_COMPARISON_DATA: null,
  PUBLISH_REVIEW: null,
  EXIT_INTENT_WITH_CHANGES: null,
  EXIT_INTENT_WITH_SKIP_UPDATE_INTEGRATIONS: null,
  EXIT_INTENT_WITH_SKIP_CREATE_INTEGRATIONS: null,
  REMOVE_PAYMENT: null
});
export const PanelKeys = keyMirror({
  PROPERTY_CREATE: null
});